import { FunctionNodeModel } from "@/models/nodes/FunctionNodeModel";
import { GroupNodeModel } from "@/models/nodes/GroupNodeModel";
import { OperatorSymbolNodeModel } from "@/models/nodes/OperatorSymbolNodeModel";
import { VariableNodeModel } from "@/models/nodes/VariableNodeModel";

import type { WrappableContainer } from "./types";
import type { InlineNodeModel } from "@/models/nodes/InlineNodeModel";
import type { NodeModel } from "@/models/nodes/types";

export function isWrappable(node: NodeModel): node is Maybe<WrappableContainer> {
  if (node.is(GroupNodeModel)) {
    if (node.casesSystemEnabled) return false;

    const { rows = 1, cols = 1 } = node.matrixNode ?? {};
    if (rows !== 1 || cols !== 1) {
      return false;
    }

    return hasInternalBreakPoint(getContainerParameters(node));
  }

  if (node.is(FunctionNodeModel)) {
    return hasInternalBreakPoint(node.parameters);
  }

  if (node.is(VariableNodeModel)) {
    return node.hasParams && hasInternalBreakPoint(node.parameters);
  }

  return false;
}

export function getContainerParameters(container: WrappableContainer): InlineNodeModel[] {
  if (container.is(GroupNodeModel)) {
    return container.inlineNode ? [container.inlineNode] : [];
  }

  return container.parameters;
}

function hasInternalBreakPoint(parameters: InlineNodeModel[]): boolean {
  if (parameters.length > 1) {
    return true;
  }

  return parameters.some((inline) => inline.nodes.some((n) => n.is(OperatorSymbolNodeModel)));
}
